export enum Status {
  Inactive = 0,
  Active = 1,
}

export enum SriEnvironment {
  PRODUCTION = '2',
  TEST = '1',
}

export enum ProductType {
  Asset = '01',
  Service = '02',
}

export enum ProductClassification {
  Inventory = '01',
  Expense = '02',
  Internal = '03',
}

export enum MeasurementUnit {
  MM = 0,
  G = 1,
  CM = 2,
  IN3 = 3,
  IN = 4,
  OZ = 5,
  FLOZ = 6,
  FT2 = 7,
  Hours = 8,
  FT = 9,
  LB = 10,
  QT = 11,
  Units = 12,
  Days = 13,
  M = 14,
  M2 = 15,
  L = 16,
  KG = 17,
  Roll = 18,
  Unsorted = 19,
  Gal = 20,
  Dozens = 21,
}

export enum MeasurementCategory {
  LengthDistance = 0, //
  Weight = 1,
  Volume = 2,
  Surface = 3,
  WorkingHours = 4,
  Unit = 5,
  Unsorted = 6,
}

export enum SriValidationOptions {
  Authorized = 0, //
  Create = 1,
  NoAuthorized = 2,
  NoCreate = 3,
}

export enum PaymentOptions {
  Paid = 0, //
  Pending = 1,
}

export enum SaleStatus {
  Inactive = 0,
  Active = 1,
  Send = 2,
  NoSend = 3,
}

export enum PaymentMethod {
  CASH = '01', // SIN UTILIZACION DEL SISTEMA FINANCIERO
  COMPENSATION = '15', // COMPENSACIÓN DE DEUDAS
  DEBIT_CARD = '16', // TARJETA DE DÉBITO
  DIGITAL_MONEY = '17', // DINERO ELECTRÓNICO
  PREPAID_CARD = '18', // TARJETA PREPAGO (agregado)
  CREDIT_CARD = '19', // TARJETA DE CRÉDITO
  OTHER = '20', // OTROS CON UTILIZACION DEL SISTEMA FINANCIERO
  TITLE_ENDORSEMENT = '21', // ENDOSO DE TÍTULOS
}

export enum DocumentType {
  Invoice = 0,
}

export enum TypeIdentification {
  RUC = '04',
  IDE = '05',
  PASSPORT = '06',
  FINAL_CONSUMER = '07',
  OUTDOOR_IDE = '08',
}

export enum TypePerson {
  Natural = 0,
  Legal = 1,
}

export enum TypeRetention {
  VatRetention = 0,
  IrRetention = 1,
}

export enum ErrorCode {
  OK = 200,
}

export enum TypeNote {
  Sale = 0,
  Purchase = 1,
}

export enum StatusBilling {
  Cancel = 0,
  Active = 1,
}

// Estado de mapeo de una factura de compra importada de forma masiva.
// Objeto const y no enum: el backend envía pendingMapping como booleano y getEnumResource
// compara con ===, cosa que un enum de TypeScript (solo string/number) nunca cumpliría.
export const PurchaseMappingStatus = {
  Complete: false,
  Pending: true,
} as const;

export enum TypeWithholding {
  IR = 0,
  IVA = 1,
}

export enum GlobalOrProprietary {
  Global = 1,
  Proprietary = 0,
}

export enum RegimeType {
  ENTREPRENEUR = 0,
  POPULAR_BUSINESS = 1,
  GENERAL = 2,
  MICROENTERPRISE = 3,
}

export enum ResolutionNumber {
  NOT_APPLICABLE = 'NA',
  NAC_DNCRASC20_00000001 = 'NAC_DNCRASC20_00000001',
  NAC_DGERCGC20_00000057 = 'NAC_DGERCGC20_00000057',
}

export enum StatusNote {
  Cancel = 0,
  Active = 1,
}

export enum TaxCode {
  RENTA = '1',
  IVA = '2',
  ICE = '3',
  IRBPNR = '5',
  ISD = '6',
}

export enum UserRole {
  ADMINISTRATOR = 1,
  ACCOUNTANT = 2,
  READER = 3,
  EDITOR = 4,
  MANAGER = 5,
}

export enum StatusCreditNote {
  Cancelled = 0,
  Active = 1,
}

export enum StatusDebitNote {
  Cancelled = 0,
  Active = 1,
}

export enum ModifiedDocCode {
  Invoice = '01',
  CreditNote = '04',
}

export enum PaymentLocationType {
  Local = '01',
  Exterior = '02',
}

export enum FiscalRegimeType {
  General = '01',
  TaxHaven = '02',
  PreferentialFiscalRegime = '03',
}

export enum DoubleTaxationOption {
  Yes = 'SI',
  No = 'NO',
  NotApplicable = 'NA',
}
